import { motion } from "framer-motion";

export function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7F5F2] text-stone-800 p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-center"
      >
        <h1 className="font-serif text-4xl md:text-5xl font-bold mb-6">
          Gopel Kujo
        </h1>
        <p className="text-stone-500 mb-8">Welcome to my personal space.</p>
        <a
          href="https://gopelkujo.com"
          className="inline-block px-6 py-3 border border-stone-800 rounded-full text-stone-800 hover:bg-stone-800 hover:text-white transition-all duration-300"
        >
          Visit gopelkujo.com
        </a>
      </motion.div>
    </div>
  );
}
